// extracted by mini-css-extract-plugin
export var bodySections = "_9y-8";
export var gray = "_9y-7";
export var green = "_9y-4";
export var iconContainer = "_9y-9";
export var iconWidgetContainer = "_9y-1";
export var phoneIcon = "_9y-2";
export var red = "_9y-5";
export var statusDot = "_9y-3";
export var widgetContainer = "_9y-0";
export var yellow = "_9y-6";